// utils
import * as THREE from "three";
import {TextureLoader} from "three";

export function loadPrimaryTextures(textureLoader: TextureLoader) {
    const baseColorTexture = textureLoader.load("terrainMaps/Canyon_Rocky_Ground_vbooeagg_1K_BaseColor.jpg");
    baseColorTexture.colorSpace = THREE.SRGBColorSpace;
    makeTextureRepeat(baseColorTexture);
    
    const aoMapTexture = textureLoader.load("terrainMaps/Canyon_Rocky_Ground_vbooeagg_1K_AO.jpg");
    makeTextureRepeat(aoMapTexture, 15);
    
    const normalMapTexture = textureLoader.load("terrainMaps/Canyon_Rocky_Ground_vbooeagg_1K_Normal.jpg");
    makeTextureRepeat(normalMapTexture);
    
    return {
        baseColorTexture,
        aoMapTexture,
        normalMapTexture,
    }
}

export function makeTextureRepeat(texture: THREE.Texture, repeatTimes = 0) {
    if (repeatTimes > 0)
        texture.repeat.set(repeatTimes, repeatTimes);
    texture.wrapT = THREE.RepeatWrapping;
    texture.wrapS = THREE.RepeatWrapping;
}